export default {
  SECTION_WIDGET_CONTACT: {
    container: {
      cellWidth: {
        100: {
          allow: true,
        },
        66.67: {
          allow: true,
        },
        58.33: {
          allow: true,
        },
        50: {
          allow: true,
        },
        41.67: {
          allow: false,
        },
        33.33: {
          allow: false,
        },
        25: {
          allow: false,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true,
        },
        66.67: {
          allow: true,
        },
        58.33: {
          allow: true,
        },
        50: {
          allow: true,
        },
        41.67: {
          allow: false,
        },
        33.33: {
          allow: false,
        },
        25: {
          allow: false,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
  },
};
